import PropTypes from 'prop-types';
import useFooterQuery from 'queries/useFooterQuery';
import FooterCore from '@activebrands/core-web/components/Footer';
import FooterBottom from 'components/Footer/FooterBottom';
import FooterMenu from 'components/Footer/FooterMenu';
import transformHeading from '@activebrands/core-web/libs/storyblok/utils/transform-heading';
import transformParagraph from '@activebrands/core-web/libs/storyblok/utils/transform-paragraph';

const Footer = ({ alternateHrefs = [], previewDataOverride }) => {
    const content = previewDataOverride || useFooterQuery();

    const {
        items,
        featuredLinks,
        featuredLinksLabel,
        informationHeading,
        informationParagraphs,
        footerContent,
        copywriteText,
    } = content;

    return (
        <FooterCore footerContent={footerContent} $style={{ borderTop: '0.5px solid var(--color-contrast-lower)' }}>
            <FooterMenu
                featuredLinks={featuredLinks}
                featuredLinksLabel={featuredLinksLabel}
                informationHeading={transformHeading({ heading: informationHeading })}
                informationParagraphs={informationParagraphs.map((paragraph) => transformParagraph({ paragraph }))}
                items={items || []}
            />
            <FooterBottom alternateHrefs={alternateHrefs} copywriteText={copywriteText} />
        </FooterCore>
    );
};

Footer.propTypes = {
    alternateHrefs: PropTypes.array,
    previewDataOverride: PropTypes.object,
};

export default Footer;
